{
  "lastUpdatedAt": "2026-07-09T08:42:57.760Z",
  "lastFetchAttemptAt": "2026-07-09T08:42:57.760Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}